var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForecaster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.66667C11.8409 8.66667 13.3333 7.17428 13.3333 5.33333C13.3333 3.49238 11.8409 2 10 2C8.15905 2 6.66667 3.49238 6.66667 5.33333C6.66667 7.17428 8.15905 8.66667 10 8.66667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0889 12.6896L15.3959 14.3047M8.91564 13.0008L4.25019 16.4999M17.4672 13.8661C17.9554 14.3543 17.9554 15.1457 17.4672 15.6339C16.9791 16.122 16.1876 16.122 15.6995 15.6339C15.2113 15.1457 15.2113 14.3543 15.6995 13.8661C16.1876 13.378 16.9791 13.378 17.4672 13.8661ZM4.13388 16.3661C4.62204 16.8543 4.62204 17.6457 4.13388 18.1339C3.64573 18.622 2.85427 18.622 2.36612 18.1339C1.87796 17.6457 1.87796 16.8543 2.36612 16.3661C2.85427 15.878 3.64573 15.878 4.13388 16.3661ZM10.8006 11.3661C11.2887 11.8543 11.2887 12.6457 10.8006 13.1339C10.3124 13.622 9.52094 13.622 9.03278 13.1339C8.54463 12.6457 8.54463 11.8543 9.03278 11.3661C9.52094 10.878 10.3124 10.878 10.8006 11.3661Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecaster);
export default __webpack_public_path__ + "static/media/forecaster.5cd5c319.svg";
export { ForwardRef as ReactComponent };